// Config por build (Vite): el orquestador inyecta las VITE_* al buildear; en
// dev salen de .env.local. Si falta algo la app lo dice en pantalla en vez de
// fallar en silencio, igual que la torre.
//
// Lo que NO esta aca, a proposito: ninguna planta. El portal es de una
// empresa que trabaja para varias plantas y la lista sale de la sesion
// (ADR-015 §5), nunca del build.
import { resolveMapProvider, type MapProvider } from "@ucorp/web-map";

export interface PortalConfig {
  /** URL base de la API (sin barra final). */
  apiUrl: string;
  userPoolId: string;
  /** App client `portal` del pool administrativo. */
  clientId: string;
}

export function readConfig(): PortalConfig | null {
  const apiUrl = import.meta.env.VITE_API_URL as string | undefined;
  const userPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined;
  const clientId = import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined;
  if (!apiUrl || !userPoolId || !clientId) return null;
  return { apiUrl: apiUrl.replace(/\/+$/, ""), userPoolId, clientId };
}

/**
 * Mapa de la flota (PP-51): Google Maps JavaScript si el build trae la clave
 * web y el Map ID (los inyecta el pipeline desde SSM, como en la torre); si
 * no, "Mapa no configurado" y la lista sigue. El portal nunca dibuja MapLibre
 * (ADR-020 enmienda 2): VITE_MAP_PROVIDER no aplica aca.
 */
export function readMapProvider(): MapProvider {
  return resolveMapProvider(import.meta.env, { allowMapLibre: false });
}
